export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'
